import { api } from '../core';
import { PageUpdate } from './types';

export interface ClearUserFlagsRequest {
  pageIds: string[];
}

// Response is directly an array of PageUpdate objects
export type ClearUserFlagsResponse = PageUpdate[];

export interface ClearUserFlagsProps {
  abortController?: AbortController;
  pageIds: string[];
  documentId?: string;
}

const clearUserFlagsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    clearUserFlags: builder.mutation<ClearUserFlagsResponse, ClearUserFlagsProps>({
      query: ({ abortController = new AbortController(), pageIds }: ClearUserFlagsProps) => ({
        url: '/gdpr/clear-flags',
        method: 'POST',
        signal: abortController.signal,
        body: {
          pageIds
        }
      }),
      // Remove cache invalidation since we'll handle local updates
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useClearUserFlagsMutation } = clearUserFlagsApi;
